// opervex-frontend/src/Opervex/Accounting/States.js

class States {
  constructor(api) {
    this._api = api;
  }

  async create(data) {
    return this._api.post("/Accounting/States/", data);
  }

  async update(id, data) {
    return this._api.put("/Accounting/States/" + id, data);
  }

  async findId(id) {
    return this._api.get("/Accounting/States/" + id);
  }

  async findAll() {
    return this._api.get("/Accounting/States");
  }
}

export default States;
